import React from 'react';
import parse from 'html-react-parser';
import clsx from 'clsx';

import { PageBranding } from 'components/Branding';
import { PlateEditor } from 'components/PlateEditor';
import { useDocumentSettings } from 'components/PlateEditor/plugins/document-settings/useDocumentSettings';
import { transformHtmlToLightbox } from '../../../components/Lightbox/utils/transformHtmlToLightbox';

const Note = ({
  isEdit,
  isTemplate,
  jsonContent,
  html,
  isMigrated,
  updateNoteContent,
  showBrandingHeader,
  branding,
  brandingContent,
  toolbarProps,
  metadata,
}) => {
  const { ref, documentSettings } = useDocumentSettings(metadata);

  const handleEditorChange = (value) => {
    updateNoteContent(value);
  };

  if (showBrandingHeader === null) {
    return <>Loading...</>;
  }

  if (showBrandingHeader && !branding) {
    return <>Loading...</>;
  }

  // Set margins for page.
  const {
    margin_bottom_pt,
    margin_top_pt,
    margin_left_pt,
    margin_right_pt,
  } = branding?.templateDict || {};

  const pageStyle = {
    paddingTop: `${margin_top_pt}pt`,
    paddingRight: `${margin_right_pt}pt`,
    paddingBottom: `${margin_bottom_pt}pt`,
    paddingLeft: `${margin_left_pt}pt`,
    ... branding?.templateDict && {
      '--pagePaddingTop': `${margin_top_pt}pt`,
      '--pagePaddingRight': `${margin_right_pt + 1}pt`,
      '--pagePaddingBottom': `${margin_bottom_pt}pt`,
      '--pagePaddingLeft': `${margin_left_pt + 1}pt`,
    },
  };

  return (
    <div
      ref={ref}
      className={clsx('project-note', 'project-note--view', showBrandingHeader && 'project-note--has-header')}
      style={pageStyle}
    >
      {showBrandingHeader && (
        <PageBranding
          logo={branding.logo}
          template={branding.templateDict}
          content={isMigrated === false && brandingContent}
        />
      )}
      {!isEdit ? (
        <div
          className={clsx(
            'ap-slate-editor',
            'ap-slate-editor--preview',
            isMigrated === false && 'ap-slate-editor--needs-migration',
          )}
        >
          {parse(html ?? '', {
            transform: transformHtmlToLightbox,
          })}
        </div>
      ) : (
        <div>
          <PlateEditor
            rootElement={ref.current}
            onChange={handleEditorChange}
            initialValue={jsonContent}
            stickyProps={{
              offset: isTemplate ? 45 : 85,
            }}
            toolbarProps={toolbarProps}
            documentSettings={documentSettings}
          />
        </div>
      )}
    </div>
  );

};

export default Note;
